import { inject, Injectable } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { IDomainUserData } from 'src/app/features/domain-user/models/domain-user-data';
import { IDomainUserListData } from 'src/app/features/domain-user/models/domain-user-list-data';
import { DomainPageService } from 'src/app/features/domain/services/domain-page.service';
import { _PageService } from './_page.service';
import { TRouteCreate } from '../route-service/models/route-create';
import { ILevelDomainData } from '../../models/level-domain-data';
import { ILevelDomainListData } from '../../models/level-domain-list-data';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

export abstract class _LevelDomainPageService
    extends _PageService
{
    abstract pageDomain_goto(domainUser: IDomainUserData | IDomainUserListData): void;

    protected readonly _domainPageService = injectRequired(DomainPageService);
    protected readonly _route = injectRequired(ActivatedRoute);

    constructor(
        // null = geen create-pagina (bv. FunctionMember: alleen via de checklists).
        protected __routeCreate: TRouteCreate | null,
    ){
        super(
            __routeCreate,
        );

        this.PageCreate_name
    }

    protected _pageDomain_goto(domainUser: IDomainUserData | IDomainUserListData): void {
        this._domainPageService.pageRoute_goto(domainUser);
    }
}
